import merge from 'deepmerge'
import moment from 'moment'

export const saveSetting = (state, object) => {
	const settings = merge(state.settings, object)
	localStorage.setItem('shiseido-settings', JSON.stringify(settings))
	state.settings = settings
}

export const deleteSetting = (state, key) => {
	if (state.settings[key]) delete state.settings[key]
	localStorage.setItem('shiseido-settings', JSON.stringify(state.settings))
}

export const login = (state, token) => {
	if (state.settings.remember) {
		localStorage.setItem('shiseido-token', token)
	}
	else {
		localStorage.removeItem('shiseido-token')
	}
	state.token = token
}

export const logout = (state, server) => {
	localStorage.removeItem('shiseido-token')
	state.token = null
}

export const setOptions = (state, options) => {
	state.options = options
}
export const editProject = (state, project) => {
	project.year = project.installationDate ? Number(moment(project.installationDate).year()) : 'na'
	project.age = project.installationDate ? moment().diff(project.installationDate, 'years') : 'na'
	project.costPerSqm = project.sqm ? Math.round(project.totalCost / project.sqm) : 'na'
	project.projectType = project.isArchive ? 'pt2' : 'pt1'
	state.projects[project.id] = project
}
export const setProjects = (state, projects) => {
	state.projects = projects
}
export const addProject = (state, project) => {
	project.year = project.installationDate ? Number(moment(project.installationDate).year()) : 'na'
	project.age = project.installationDate ? moment().diff(project.installationDate, 'years') : 'na'
	project.costPerSqm = project.sqm ? Math.round(project.totalCost / project.sqm) : 'na'
	project.projectType = project.isArchive ? 'pt2' : 'pt1'
	state.projects[project.id] = project
}
export const removeProject = (state, id) => {
	if (state.projects[id]) delete state.projects[id]
}
export const addIndex = (state, index) => {
	state.indexes.push(index)
}
export const removeIndex = (state, index) => {
	state.indexes.splice(index, 1)
}
export const setIndexes = (state, indexes) => {
	state.indexes = indexes
}
export const setProjectsFile = (state, path) => {
	state.projectsFile = path
}

export const setNotifications = (state, notifications) => {
	state.notifications = notifications
}
export const removeNotification = (state, id) => {
	const index = Object.values(state.notifications).findIndex(item => item.id === id)
	if (index !== -1) {
		state.notifications.splice(index, 1)
	}
}
export const readNotification = (state, id) => {
	Object.values(state.notifications).forEach(item => {
		if (item.id === id) {
			item.isRead = true
		}
	})
}
export const setNotificationsToken = (state, token) => {
	state.notificationsToken = token
}

export const setProp = (state, prop) => {
	state.projects[prop.id][prop.option] = prop.value
	if (prop.option === 'installationDate') {
		state.projects[prop.id].age = prop.value ? moment().diff(prop.value, 'years') : 'na'
		state.projects[prop.id].year = prop.value ? Number(moment(prop.value).year()) : 'na'
	}
	else if (prop.option === 'totalCost') {
		state.projects[prop.id].costPerSqm = prop.value && state.projects[prop.id].sqm ? Math.round(prop.value / state.projects[prop.id].sqm) : 'na'
	}
	else if (prop.option === 'sqm') {
		state.projects[prop.id].costPerSqm = prop.value && state.projects[prop.id].totalCost ? Math.round(state.projects[prop.id].totalCost / prop.value) : 'na'
	}
}

export const addComment = (state, payload) => {
	state.projects[payload.project_id]['comments'].push(payload.comment)
}

export const flushData = (state) => {
	state.options = {
		brands: [],
		distributionChannel: [],
		area: [],
		country: [],
		storeType: [],
		storeLevel: [],
		openRefurbish: [],
		personalizationType: [],
		furnitureType: [],
		projectStatus: [],
		projectType: [],
	}
	state.projects = {}
	state.indexes = []
	state.projectsFile = ''
	state.notificationsToken = null
}

export const setDashboard = (state, payload) => {
	state.dashboard = payload
	localStorage.setItem('shiseido-dashboard-mode', state.dashboard)
}
export const switchDashboard = state => {
	state.dashboard = state.dashboard === 'table' ? 'cards' : 'table'
	localStorage.setItem('shiseido-dashboard-mode', state.dashboard)
}



// WEBPACK FOOTER //
// ./src/store/mutations.js